import React from 'react';
import ReviewResults from '../shared/ReviewResults';

// Render the shared ReviewResults component in admin mode to show all modules
const AllDataReview = ({ user }) => (
  <div>
    <h2 className="text-3xl font-bold mb-4 text-indigo-700">Institutional Data Review</h2>
    <p className="text-gray-600 mb-6">Aggregate and compare data across all modules. Use the table below to deep-dive into individual surveys.</p>
    <ReviewResults adminMode={true} user={user} />
  </div>
);

export default AllDataReview;